export default __webpack_public_path__ + "static/media/askquestion.1f0a6a7c.svg";